import React from 'react';
import classNames from 'classnames/bind';
import { Button } from 'gd-design-library';
import Image from 'next/image';
import SendIcon from '@assets/images/send.svg';
import styles from './SearchSendButton.module.scss';

const cx = classNames.bind(styles);
const CN = 'search-send-button';
const buttonClassName = `${CN}__button`;

interface SearchSendButtonProps {
  disabled: boolean;
  onClick: () => void;
  className?: string;
}

export const SearchSendButton: React.FC<SearchSendButtonProps> = ({
  disabled,
  onClick,
  className
}) => (
  <Button
    variant='inherit'
    isIcon
    disabled={ disabled }
    className={ cx(buttonClassName, className) }
    onClick={ onClick }
    aria-label='Send message'
  >
    <Image src={ SendIcon.src } alt='Send' width={ 13 } height={ 13 } />
  </Button>
);
